// AdvisoryBoardData.js
// Advisors grouped under a single "Advisory Board" label. Same shape as
// CoreTeamData: the group has a label and a list of members; each member has
// photo, name, role, and bio paragraphs.

import CoachXinxu from "../Assets/CoachEric.jpeg";
import MayaChavez from "../Assets/MayaChavez.jpeg";
import CoachMamtii from "../Assets/Coach-MamtiiSoudagar.jpeg";
import DrAvula from "../Assets/ASPrasad.jpeg";
import CoachJudy from "../Assets/SPTTC-Judy.jpeg";

const AdvisoryBoardData = [
  {
    category: "Advisory Board",
    members: [
      {
        name: "Xinxu Zhao",
        role: "Table Tennis Coach",
        photo: CoachXinxu,
        bio: [
          "Coach Xinxu Zhao began training at age 6 in Shenyang, China, joined the Liaoning Provincial Professional Team at age 10, and earned multiple provincial and national championships. After competing in the Japanese High School League (national ranking No. 12 in 2009), he moved to the United States in 2011 to compete and coach professionally.",
          "Over the past decade, Coach Xinxu has trained an estimated 400–500 students in Seattle, producing 11 Washington State champions and world-stage athletes — including Crystal Wang (Tokyo Olympics roster), Zexuan Wang (Paris Olympics roster), and Jessica Reyes-Lai (2024 Busan World Championships).",
        ],
      },
      {
        name: "Maya Chavez",
        role: "Physical Therapist\nDoctor of Physical Therapy",
        photo: MayaChavez,
        bio: [],
      },
      {
        name: "Mamtii Soudagar",
        role: "Table Tennis Coach",
        photo: CoachMamtii,
        bio: [
          "As a professional table tennis player, Mamtii played competitively for over 10 years. He was selected to be a member of the Iranian National Team from 1995–2003. From 2003–2011, Mamtii played in the Iran Super League and coached in several prestigious clubs in Tehran.",
          "After moving to the US in 2014, he transitioned into a full-time coaching position. Coach Mamtii is eager to share his skills with table tennis enthusiasts of all ages and skill levels.",
        ],
      },
      {
        name: "Dr. Siva Svp Avula, MD",
        role: "Psychiatrist",
        photo: DrAvula,
        bio: [
          "Dr. Siva Svp Avula, MD, is a patient-centered psychiatrist with over one decade of clinical experience specializing in the diagnosis and treatment of complex mental health and neurological conditions. Dr. Avula has a diverse clinical background, having worked across multiple healthcare settings including hospitals, outpatient clinics, and community mental health programs.",
          "With extensive experience in diagnosing and treating a wide range of psychiatric conditions including anxiety disorders, depression, mood disorders, and stress-related conditions, Dr. Avula is known for building strong therapeutic relationships with patients, emphasizing open communication, empathy, and respect. His clinical approach combines medication management with supportive psychotherapy, helping patients achieve long-term emotional well-being and improved quality of life.",
          "Dr. Avula has developed expertise in the psychiatric care of patients with Parkinson's disease, addressing complex challenges such as depression, anxiety, cognitive changes, and behavioral symptoms associated with neurological conditions. Recognizing the growing evidence supporting exercise in improving both mental health and neurological function, he encourages patients — especially those with Parkinson's and age-related conditions — to incorporate structured physical activity into their daily lives as part of a comprehensive treatment plan.",
          "Dr. Avula also provides mental health care within correctional settings across California, working in prison systems and caring for a diverse and often underserved population. He addresses complex psychiatric conditions including severe mental illness, substance use disorders, trauma-related disorders, and behavioral challenges.",
        ],
      },
      // 5th member → wraps to the 2nd row of the About-page grid,
      // directly below Xinxu Zhao (column 1).
      {
        name: "Judy",
        role: "Table Tennis Coach",
        photo: CoachJudy,
        bio: [],
      },
    ],
  },
];

export default AdvisoryBoardData;